module.exports = __webpack_public_path__ + "media/images/faces/male/3-947c7e67e75547ef24121f8b2bde9f08.jpg";